
import AxiosClient from "../../../services/axios.services";

class PlantillaCompetenciaServices {
  getPlantillaCompetencias = params =>
    AxiosClient.get("/api/app/evaluacion_competencia_plantilla_encabezado/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getPlantillaCompetencia = id =>
    AxiosClient.get(`/api/app/evaluacion_competencia_plantilla_encabezado/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  savePlantillaCompetencia = data =>
    AxiosClient.post("/api/app/evaluacion_competencia_plantilla_encabezado/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPlantillaCompetencia = (id, data) =>
    AxiosClient.put(
      `/api/app/evaluacion_competencia_plantilla_encabezado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePlantillaCompetencia = id =>
    AxiosClient.delete(`/api/app/evaluacion_competencia_plantilla_encabezado/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  copyCompetencyTemplate = (data) =>
    AxiosClient.post("/api/app/copiado_evaluacion_plantilla_competencia/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new PlantillaCompetenciaServices();